module.exports = __webpack_public_path__ + "img/historyImg4.189bb936.png";